export function isSome(input) {
  return input.ok;
}
export function createSome(val) {
  var r = {
    ok: true,
    val: val
  };
  return r;
}
export function isNone(input) {
  return !input.ok;
}
export function createNone() {
  var r = {
    ok: false,
    // XXX: We need to fill with `null` to improve the compatibility with Next.js
    // see https://github.com/karen-irc/option-t/pull/1256
    val: null
  };
  return r;
}